import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { CartProvider } from './contexts/CartContext';
import { ShopLayout } from './components/layout/ShopLayout';
import { ScrollToTop } from './components/layout/ScrollToTop';
import { Home } from './pages/Home';
import { Collection } from './pages/Collection';
import { Product } from './pages/Product';
import { Checkout } from './pages/Checkout';
import { About } from './pages/About';
import { NotFound } from './pages/NotFound';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2mn5fgugf19n1">
      <CartProvider data-id="element-1" data-mp="2mjpuxc3z38e8">
        <ScrollToTop data-id="element-2" data-mp="31aqd48uiugnk" />
        <Routes data-id="element-3" data-mp="31b8lg3ugklbu">
          <Route path="/afrekenen" element={<Checkout data-id="element-5" data-mp="31ctefp14jw7l" />} data-id="element-4" data-mp="31bs09botatln" />
          <Route element={<ShopLayout data-id="element-7" data-mp="2wjgrrkg09zhh" />} data-id="element-6" data-mp="2wk0av4he6tx3">
            <Route path="/" element={<Home data-id="element-9" data-mp="2wip6p3k1bk5g" />} data-id="element-8" data-mp="2wj8dpp85co4p" />
            <Route path="/collectie/:slug" element={<Collection data-id="element-11" data-mp="28te21azkd5m1" />} data-id="element-10" data-mp="28ufqch5lbolp" />
            <Route path="/product/:slug" element={<Product data-id="element-13" data-mp="23vkw8j26adma" />} data-id="element-12" data-mp="28sl48zil1qg1" />
            <Route path="/over-amira" element={<About data-id="element-15" data-mp="23v2sz2h3ez4v" />} data-id="element-14" data-mp="23w4c7u89irxo" />
            <Route path="*" element={<NotFound data-id="element-17" data-mp="3ikhaeg9qb525" />} data-id="element-16" data-mp="3ijxpcqos80jw" />
          </Route>
        </Routes>
      </CartProvider>
    </BrowserRouter>;
}